import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NotificationIconComponent } from './notification-icon/notification-icon.component';
import { NotificationsService } from './services/notifications.service';
import { NotificationBannerComponent } from './notification-banner/notification-banner.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [
    MatIconModule,
    TranslateModule,
    CommonModule,
    RouterModule,
  ],
  declarations: [
    NotificationIconComponent,
    NotificationBannerComponent,
  ],
  providers: [
    NotificationsService,
  ],
  exports: [
    NotificationIconComponent,
    NotificationBannerComponent,
  ],
})
export class NotificationsModule {
}
